import { useContext } from 'react';

import { invariant } from '@e-socna/utils';

import { FolderContext } from '../index';

export const useFolderContext = () => {
  const context = useContext(FolderContext);

  invariant(
    !!context,
    'useFolderContext must be used within a FolderContextProvider',
  );

  return context;
};
